import { render, staticRenderFns } from "./SavePassword.vue?vue&type=template&id=248c548d&"
import script from "./SavePassword.vue?vue&type=script&lang=js&"
export * from "./SavePassword.vue?vue&type=script&lang=js&"
import style0 from "./SavePassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports